import { create } from 'zustand';
import type { UserCompanyDto } from '@monorepo/shared';

interface UserCompaniesState {
  companies: UserCompanyDto[];
  setCompanies: (companies: UserCompanyDto[]) => void;
  clearCompanies: () => void;
}

export const useUserCompaniesStore = create<UserCompaniesState>((set) => ({
  companies: [],
  setCompanies: (companies) => set({ companies }),
  clearCompanies: () => set({ companies: [] }),
}));
